import { ResultMessage } from "./result-message";
import { TableResults } from "./table-results";
import { ResponseFeedback } from "./response-feedback";

type AIAnswerProps = {
  content?: string;
  data: unknown;
  onDownloadResults: () => void;
  onFeedback: (isPositive: boolean) => void;
  selectedFeedback: "positive" | "negative" | null;
};

export function AIAnswer({
  content,
  data,
  onDownloadResults,
  onFeedback,
  selectedFeedback,
}: AIAnswerProps) {
  const isTable = !!data && Array.isArray(data) && data.length > 0;

  return (
    <div className="flex flex-col gap-4">
      <ResultMessage content={content} />
      {isTable && (
        <TableResults onDownload={onDownloadResults} data={data as any[]} />
      )}
      <ResponseFeedback
        onFeedback={onFeedback}
        selectedFeedback={selectedFeedback}
      />
    </div>
  );
}
